export const handleChangeInputLoginPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_LOGIN', name, value
});

export const handleChangeDisabledBtnPageLogin = (disabledBtn) => ({
    type: 'CHANGE_DISABLE_BTN_PAGE_LOGIN', disabledBtn
});

export const handleChangeLoaderPageLogin = (isLoading) => ({
    type: 'CHANGE_LOADER_PAGE_LOGIN', isLoading
});

export const handleChangeBtnClassPageLogin = (className) => ({
    type: 'CHANGE_BTN_CLASS_PAGE_LOGIN', className
});